// @flow weak

import { appConfig } from '../../config';
import {
  jsonHeaderAuth,
  refreshAuthLogic
} from '../fetchTools';
import axios from 'axios';
import createAuthRefreshInterceptor from 'axios-auth-refresh';

// Function that will be called to refresh authorization


// Instantiate the interceptor (you can chain it as it returns the axios instance)

export const getAllCustomer = async () => {
  createAuthRefreshInterceptor(axios, refreshAuthLogic);  
  const url = `${appConfig.BASE_API}/customer/readall`;  
  const result=await axios.get(url,jsonHeaderAuth())
  .then(res=>{
    console.log('getallcustomer',res.data)
    return res.data
    })    
   .catch (error=> {
    // console.log('error', error)
    return null;
  })
  return result
  
};

export const getCustomer = async (id) => {
  createAuthRefreshInterceptor(axios, refreshAuthLogic);    
  const url = `${appConfig.BASE_API}/customer/read/${id}`;
  
  const result=await axios.get(url,jsonHeaderAuth())
  .then(res=>{
    // console.log('getallcustomer',res.data)
    return res.data
    })    
   .catch (error=> {
    // console.log('error', error)
    return null;
  })
  return result
  
};

export const createCustomer = async (req) => {
  createAuthRefreshInterceptor(axios, refreshAuthLogic);      
  const url = `${appConfig.BASE_API}/customer/create`;
  
  const result=await axios.post(url,req,jsonHeaderAuth())
  .then(res=>{
    // console.log('getallcustomer',res.data)
    if (res.Data)
      return res.data
    else
      return { 'status': 'OK' };
    })    
   .catch (error=> {
    // console.log('error', error)
    return 'error';
  })
  return result  
};

export const deleteCustomer = async (id) => {
  createAuthRefreshInterceptor(axios, refreshAuthLogic);    
  const url = `${appConfig.BASE_API}/customer/delete/${id}`;
  const result=await axios.get(url,jsonHeaderAuth())
  .then(res=>{
    console.log('getallcustomer',res.data)    
      return res.data    
    })    
   .catch (error=> {
    // console.log('error', error)
    return 'error';
  })
  return result   
  
};

export const updateCustomer = async (cnumb, req) => {
  createAuthRefreshInterceptor(axios, refreshAuthLogic);  
  const url = `${appConfig.BASE_API}/customer/update/${cnumb}`;
  
  const result=await axios.post(url,req,jsonHeaderAuth())
  .then(res=>{
    console.log('update customer',res)
    if (res.status)
      return true
    else
      return false
    })    
   .catch (error=> {
    // console.log('error', error)
    return false
  })
  return result 
};

export const getCustomerByUser = async (userId) => {
  createAuthRefreshInterceptor(axios, refreshAuthLogic);  
  const url = `${appConfig.BASE_API}/deviceuser/readbyuserid/${userId}`;
  
  const result=await axios.get(url,jsonHeaderAuth())
  .then(res=>{    
      return res.data
    })    
   .catch (error=> {
    // console.log('error', error)
    return null
  })
  return result 
  
};

export const updateAutoConsumable = async (req) => {
  createAuthRefreshInterceptor(axios, refreshAuthLogic);  
  const url = `${appConfig.BASE_API}/customer/updateAutoConsumable`;
  
  const result=await axios.post(url,req,jsonHeaderAuth())
  .then(res=>{
    console.log('SERVICE res edit auto consum',res)
    if (res.status==200)
    {
      window.location.reload();
      return true
    }
    else
    {
      return false
    }
    })    
   .catch (error=> {
    // console.log('error', error)
    return false
  })
  return result 
};

export const searchCustomer = async (req) => {
  createAuthRefreshInterceptor(axios, refreshAuthLogic);      
  const url = `${appConfig.BASE_API}/customer/search`;
  const result=await axios.post(url,req,jsonHeaderAuth())
  .then(res=>{
    //console.log('get customer with paging',res.data)
    return res.data
    })    
   .catch (error=> {
      console.log('error searchCustomer()', error)
    return null;
  })
  return result  
};